interface PricelistTableCellLinesProps {
  lines: string[];
}

export const PricelistTableCellLines = ({ lines }: PricelistTableCellLinesProps) => (
  <div className="request-table-cell-lines">
    {lines.map((line, index) => (
      <span key={`${line}-${index}`} className="request-table-cell-lines__item">
        {line}
      </span>
    ))}
  </div>
);
